import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, Grid } from '@nu-art/thunderstorm-frontend';
import { cloneObj, compare, exists, voidFunction } from '@nu-art/ts-common';
import { Component_PrettyPrint_Term } from '../Component_PrettyPrint_Term/Component_PrettyPrint_Term.js';
import './Component_PrettyPrint_ComplexTerm.scss';
import { DBDef_Expression, DBDef_Variable } from '@app/hcs-shared';
export class Component_PrettyPrint_ComplexTerm extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(props, state) {
        state.term = props.term ? cloneObj(props.term) : undefined;
        state.termIndex = props.termIndex;
        state.interactive = props.interactive;
        return state;
    }
    shouldReDeriveState(nextProps) {
        return super.shouldReDeriveState(nextProps)
            || !compare(nextProps.term, this.state?.term);
    }
    //######################### Logic #########################
    getAtomToVarMap = () => {
        return this.state.term?.atoms.reduce((map, atom, index) => {
            const type = atom.leftHand?.type === 'expression'
                ? DBDef_Expression.dbKey
                : atom.leftHand?.type === 'variable'
                    ? DBDef_Variable.dbKey
                    : undefined;
            if (exists(type) && exists(atom.leftHand?.id))
                map[index] = { type, id: atom.leftHand.id };
            return map;
        }, {}) ?? {};
    };
    getRenderValueFromRange = (range) => {
        if (!range)
            return '';
        if (range[0] === range[1])
            return String(range[0]);
        return `[${range[0]},${range[1]}]`;
    };
    //######################### Render #########################
    render() {
        return _jsxs(Grid, { className: 'complex-term-description', children: [_jsxs(Grid, { className: 'description-row', children: [_jsx("div", { className: 'description-row__indicator' }), _jsx("div", { className: 'description-row__title', children: "One of the following options:" })] }), ...this.render_SubTerms(), _jsxs(Grid, { className: 'description-row', children: [_jsx("div", { className: 'tree-line-connector' }), _jsx("div", { className: 'description-row__title', children: "Otherwise:" }), _jsx("div", { className: 'description-row__value', children: this.getRenderValueFromRange(this.state.term?.fallbackValue) })] })] });
    }
    render_SubTerms = () => {
        const rows = [];
        const atomToVarMap = this.getAtomToVarMap();
        this.state.term?.subTerms.forEach((subTerm, index) => {
            rows.push(_jsxs(Grid, { className: 'description-row', children: [_jsx("div", { className: 'tree-line-connector' }), _jsx(Component_PrettyPrint_Term, { modules: this.props.modules, term: subTerm, termIndex: index, interactive: this.state.interactive, interactiveProperties: {
                            calculationResult: undefined,
                            actualValueMap: undefined,
                            suggestedValueMap: undefined,
                            partialValueMap: undefined,
                            selectedVariableId: undefined,
                            onVariableSelected: voidFunction,
                        }, titleOverwrite: `Option ${index + 1}:`, atomToVarMap: atomToVarMap }), _jsx("div", { className: 'description-row__value', children: this.getRenderValueFromRange(subTerm.value) })] }));
        });
        return rows;
    };
}
//# sourceMappingURL=Component_PrettyPrint_ComplexTerm.js.map